<script setup lang="ts"></script>

<template>
  <RouterView />
</template>

<style>
.app-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>
